import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** One swatch in a chart's legend. `colorIndex` picks the `--chart-n` custom property, so the dot
 * matches the line the canvas drew from the same palette; `color` overrides it for a series with a
 * fixed brand color outside that palette (e.g. website visitors' identified/anonymous split).
 * `value` — a formatted total shown under the label — turns the chip into a small metric card
 * instead of a bare toggle. `tooltip` shows on hover over that value, e.g. an unrounded figure. */
export interface ChartLegendItem {
  label: string;
  colorIndex?: number;
  color?: string;
  value?: string;
  tooltip?: string;
  active: boolean;
}

/**
 * The legend the analytics charts use, drawn below the canvas instead of by Chart.js: a row of
 * coloured chips, each toggling its series. Kept dumb — the host owns the items and applies the
 * toggle to its chart.
 */
@Component({
  selector: 'app-chart-series-legend',
  templateUrl: './chart-series-legend.component.html',
  styleUrl: './chart-series-legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChartSeriesLegendComponent {
  @Input() public items: ChartLegendItem[] = [];
  @Output() public toggleSeries = new EventEmitter<number>();
}
